import { css } from '@emotion/core';
import StudiesContent from './StudiesContent';

export default function StudiesLayoutDesktop() {
    return (
        <div
            css={css`
                padding: 2rem;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
            `}
        >
            <StudiesContent />
        </div>
    );
}
